<template>
  <div class="cron-scheduler">
    <vs-row vs-type="flex">
      <vs-col
        vs-w="12"
        vs-sm="6"
        vs-lg="3"
        vs-xs="12"
      >
        <div class="m-2">
          <label class="text-sm opacity-75">{{ $t('automation.automation_type') }}</label>

          <v-select
            v-model="automationType"
            :options="automationTypeOptions"
            :clearable="false"
          />
        </div>
      </vs-col>

      <vs-col
        v-if="['daily', 'weekly', 'monthly'].includes(automationType.value)"
        vs-w="12"
        vs-sm="6"
        vs-lg="3"
        vs-xs="12"
      >
        <div class="m-2">
          <label class="text-sm opacity-75">{{ $t('automation.hours') }}</label>

          <v-select
            v-model="selectedHours"
            :options="hoursOptions"
            :placeholder="$t('automation.hourly')"
            :clearable="false"
          />
        </div>
      </vs-col>

      <vs-col
        vs-w="12"
        vs-sm="6"
        vs-lg="3"
        vs-xs="12"
      >
        <div class="m-2">
          <label class="text-sm opacity-75">{{ $t('automation.minutes') }}</label>

          <v-select
            v-model="selectedMinutes"
            :options="minutesOptions"
            :placeholder="$t('automation.every_minute')"
            :multiple="automationType.value === 'hourly'"
            :clearable="automationType.value === 'hourly'"
            required
          />
        </div>
      </vs-col>

      <vs-col
        vs-w="12"
        vs-sm="6"
        vs-lg="3"
        vs-xs="12"
        v-if="automationType.value === 'weekly'"
      >
        <div class="m-2">
          <label class="text-sm opacity-75">{{ $t('automation.days_of_week') }}</label>

          <v-select
            v-model="selectedDaysOfWeek"
            :options="daysOfWeekOptions"
            :placeholder="$t('automation.days_of_week')"
            :clearable="false"
            multiple
          />
        </div>
      </vs-col>

      <vs-col
        vs-w="12"
        vs-sm="6"
        vs-lg="3"
        vs-xs="12"
        v-if="automationType.value === 'monthly'"
      >
        <div class="m-2">
          <label class="text-sm opacity-75">{{ $t('automation.days_of_month') }}</label>

          <v-select
            v-model="selectedDaysOfMonth"
            :options="daysOfMonthOptions"
            :placeholder="$t('automation.days_of_month')"
            :clearable="false"
            multiple
          />
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
    components: {
        vSelect
    },
    props: {
        value: { required: true }
    },
    data() {
        return {
            automationType: undefined,
            selectedMinutes: [],
            selectedHours: [],
            selectedDaysOfWeek: [],
            selectedDaysOfMonth: [],
            automationTypeOptions: [
                {label: this.$t('automation.hourly'), value: 'hourly'},
                {label: this.$t('automation.daily'), value: 'daily'},
                {label: this.$t('automation.weekly'), value: 'weekly'},
                {label: this.$t('automation.monthly'), value: 'monthly'}
            ],
            minutesOptions: [
                { label: '00', value: '00' },
                { label: '01', value: '01' },
                { label: '02', value: '02' },
                { label: '03', value: '03' },
                { label: '04', value: '04' },
                { label: '05', value: '05' },
                { label: '06', value: '06' },
                { label: '07', value: '07' },
                { label: '08', value: '08' },
                { label: '09', value: '09' },
                { label: '10', value: '10' },
                { label: '11', value: '11' },
                { label: '12', value: '12' },
                { label: '13', value: '13' },
                { label: '14', value: '14' },
                { label: '15', value: '15' },
                { label: '16', value: '16' },
                { label: '17', value: '17' },
                { label: '18', value: '18' },
                { label: '19', value: '19' },
                { label: '20', value: '20' },
                { label: '21', value: '21' },
                { label: '22', value: '22' },
                { label: '23', value: '23' },
                { label: '24', value: '24' },
                { label: '25', value: '25' },
                { label: '26', value: '26' },
                { label: '27', value: '27' },
                { label: '28', value: '28' },
                { label: '29', value: '29' },
                { label: '30', value: '30' },
                { label: '31', value: '31' },
                { label: '32', value: '32' },
                { label: '33', value: '33' },
                { label: '34', value: '34' },
                { label: '35', value: '35' },
                { label: '36', value: '36' },
                { label: '37', value: '37' },
                { label: '38', value: '38' },
                { label: '39', value: '39' },
                { label: '40', value: '40' },
                { label: '41', value: '41' },
                { label: '42', value: '42' },
                { label: '43', value: '43' },
                { label: '44', value: '44' },
                { label: '45', value: '45' },
                { label: '46', value: '46' },
                { label: '47', value: '47' },
                { label: '48', value: '48' },
                { label: '49', value: '49' },
                { label: '50', value: '50' },
                { label: '51', value: '51' },
                { label: '52', value: '52' },
                { label: '53', value: '53' },
                { label: '54', value: '54' },
                { label: '55', value: '55' },
                { label: '56', value: '56' },
                { label: '57', value: '57' },
                { label: '58', value: '58' },
                { label: '59', value: '59' }
            ],
            hoursOptions: [
                { label: '00', value: '00' },
                { label: '01', value: '01' },
                { label: '02', value: '02' },
                { label: '03', value: '03' },
                { label: '04', value: '04' },
                { label: '05', value: '05' },
                { label: '06', value: '06' },
                { label: '07', value: '07' },
                { label: '08', value: '08' },
                { label: '09', value: '09' },
                { label: '10', value: '10' },
                { label: '11', value: '11' },
                { label: '12', value: '12' },
                { label: '13', value: '13' },
                { label: '14', value: '14' },
                { label: '15', value: '15' },
                { label: '16', value: '16' },
                { label: '17', value: '17' },
                { label: '18', value: '18' },
                { label: '19', value: '19' },
                { label: '20', value: '20' },
                { label: '21', value: '21' },
                { label: '22', value: '22' },
                { label: '23', value: '23' }
            ],
            daysOfWeekOptions: [
                { label: this.$t('calendar.weekdaysMin.Mo'), value: '1' },
                { label: this.$t('calendar.weekdaysMin.Tu'), value: '2' },
                { label: this.$t('calendar.weekdaysMin.We'), value: '3' },
                { label: this.$t('calendar.weekdaysMin.Th'), value: '4' },
                { label: this.$t('calendar.weekdaysMin.Fr'), value: '5' },
                { label: this.$t('calendar.weekdaysMin.Sa'), value: '6' },
                { label: this.$t('calendar.weekdaysMin.Su'), value: '7' }
            ],
            daysOfMonthOptions: [
                { label: '1', value: '1' },
                { label: '2', value: '2' },
                { label: '3', value: '3' },
                { label: '4', value: '4' },
                { label: '5', value: '5' },
                { label: '6', value: '6' },
                { label: '7', value: '7' },
                { label: '8', value: '8' },
                { label: '9', value: '9' },
                { label: '10', value: '10' },
                { label: '11', value: '11' },
                { label: '12', value: '12' },
                { label: '13', value: '13' },
                { label: '14', value: '14' },
                { label: '15', value: '15' },
                { label: '16', value: '16' },
                { label: '17', value: '17' },
                { label: '18', value: '18' },
                { label: '19', value: '19' },
                { label: '20', value: '20' },
                { label: '21', value: '21' },
                { label: '22', value: '22' },
                { label: '23', value: '23' },
                { label: '24', value: '24' },
                { label: '25', value: '25' },
                { label: '26', value: '26' },
                { label: '27', value: '27' },
                { label: '28', value: '28' },
                { label: '29', value: '29' },
                { label: '30', value: '30' },
                { label: '31', value: '31' }
            ]
        }
    },
    computed: {
        cronMinutes() {
            const value = this.selectedMinutes

            switch (true) {
            case (Array.isArray(value) && value.length === 0) || value === null:
                return  '*'
            case Array.isArray(value) && value.length > 0:
                return  value.map((item => item.value)).join(',')
            case value.hasOwnProperty('value'):
                return value.value
            default:
                return undefined
            }
        },
        cronHours() {
            if(this.selectedHours === null) {
                return '*'
            }

            return Array.isArray(this.selectedHours) && this.selectedHours.length === 0 ? '*' : this.selectedHours.value
        },
        cronDayOfMonth() {
            return this.selectedDaysOfMonth.length === 0 ? '*' : this.selectedDaysOfMonth.map((item) => item.value).join(',')
        },
        cronDaysOfWeek() {
            return this.selectedDaysOfWeek.length === 0 ? '*' : this.selectedDaysOfWeek.map((item) => item.value).join(',')
        },
        cronExpression() {
            return `${this.cronMinutes} ${this.cronHours} ${this.cronDayOfMonth} * ${this.cronDaysOfWeek}`
        }
    },
    watch: {
        automationType: {
            handler(value, oldValue) {
                if(oldValue === undefined) {
                    return
                }

                switch (value.value) {
                case 'hourly':
                    this.selectedHours = []
                    this.selectedDaysOfWeek = []
                    this.selectedDaysOfMonth = []
                    break
                case 'daily':
                    this.selectedMinutes = this.minutesOptions[0]
                    this.selectedHours = this.hoursOptions[0]
                    this.selectedDaysOfWeek = []
                    this.selectedDaysOfMonth = []
                    break
                case 'weekly':
                    this.selectedMinutes = this.minutesOptions[0]
                    this.selectedHours = this.hoursOptions[0]
                    this.selectedDaysOfWeek = []
                    this.selectedDaysOfMonth = []
                    break
                case 'monthly':
                    this.selectedMinutes = this.minutesOptions[0]
                    this.selectedHours = this.hoursOptions[0]
                    this.selectedDaysOfWeek = []
                    this.selectedDaysOfMonth = []
                    break
                }
            }
        },
        selectedMinutes(value) {
            if(value === null) {
                this.selectedMinutes = this.minutesOptions[0]
            }
        },
        cronExpression(value) {
            this.$emit('input', value)
        }
    },
    methods: {
        resolveAutomationType(hours, daysOfMonth, daysOfWeek) {
            switch (true) {
            case daysOfMonth !== '*':
                return { label: this.$t('automation.monthly'), value: 'monthly' }
            case daysOfWeek !== '*':
                return { label: this.$t('automation.weekly'), value: 'weekly' }
            case hours !== '*':
                return { label: this.$t('automation.daily'), value: 'daily' }
            default:
                return { label: this.$t('automation.hourly'), value: 'hourly' }
            }
        },
        parseCronExpression(cronExpression) {
            const [minutes, hours, daysOfMonth, , daysOfWeek] = cronExpression.split(' ')

            this.automationType = this.resolveAutomationType(hours, daysOfMonth, daysOfWeek)

            if(minutes === '*') {
                this.selectedMinutes = []
            } else {
                const splitMinutes = minutes.split(',')
                const filteredOptions = this.minutesOptions.filter(option => splitMinutes.includes(option.value))

                // can be select with single and multiple options
                this.selectedMinutes = this.automationType.value === 'hourly' ? filteredOptions : filteredOptions[0]
            }

            const splitHours = hours.split(',')

            // can be select with single option
            this.selectedHours = hours === '*' ? [] : this.hoursOptions.filter(option => splitHours.includes(option.value))[0]

            const splitDaysOfWeek = daysOfWeek.split(',')

            this.selectedDaysOfWeek = daysOfWeek === '*' ? [] : this.daysOfWeekOptions.filter(option => splitDaysOfWeek.includes(option.value))

            const dayOfMonth = daysOfMonth.split(',')

            this.selectedDaysOfMonth = daysOfMonth === '*' ? [] : this.daysOfMonthOptions.filter(option => dayOfMonth.includes(option.value))
        }
    },
    async created() {
        this.parseCronExpression(this.value)
    }
}
</script>
